import { Injectable } from '@angular/core';
import { IAppState } from '@myStore/app.state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  CreateCompanyFailure,
  CreateCompanyRequest,
  CreateCompanySuccess,
  CreateVacancyFailure,
  CreateVacancyRequest,
  CreateVacancySuccess,
  DeleteVacancyFailure,
  DeleteVacancyRequest,
  DeleteVacancySuccess,
  ECompaniesChangesActions,
  EditVacancyFailure,
  EditVacancyRequest,
  EditVacancySuccess,
} from '@myStore/companies/changes/companies-changes.actions';
import { CompaniesChangesService } from '@services/companies/changes/companies-changes.service';

@Injectable()
export class CompaniesChangesEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _toastr: ToastrService,
    private _companiesChangesService: CompaniesChangesService
  ) {}

  $createCompany = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<CreateCompanyRequest>(
          ECompaniesChangesActions.CreateCompanyRequest
        ),
        switchMap(action => {
          return this._companiesChangesService.createCompany(action.data).pipe(
            map(() => {
              this._store.dispatch(new CreateCompanySuccess());
            }),
            catchError(err => {
              this._toastr.error(
                `При создании коспании возникла ошибка (post)`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new CreateCompanyFailure(err));
              return err.statusText;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $createVacancy = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<CreateVacancyRequest>(
          ECompaniesChangesActions.CreateVacancyRequest
        ),
        switchMap(action => {
          return this._companiesChangesService.createVacancy(action.data).pipe(
            map(() => {
              this._toastr.success(`Вакансия успешно создана`, ` `, {
                timeOut: 3500,
              });
              this._store.dispatch(new CreateVacancySuccess());
            }),
            catchError(err => {
              this._toastr.error(
                `При создании вакансии возникла ошибка (post)`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new CreateVacancyFailure(err));
              return err.statusText;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $deleteVacancy = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteVacancyRequest>(
          ECompaniesChangesActions.DeleteVacancyRequest
        ),
        switchMap(action => {
          return this._companiesChangesService.deleteVacancy(action.id).pipe(
            map(() => {
              this._store.dispatch(new DeleteVacancySuccess());
            }),
            catchError(err => {
              this._toastr.error(
                `При удалении вакансии возникла ошибка (delete)`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new DeleteVacancyFailure(err));
              return err.statusText;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $editVacancy = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<EditVacancyRequest>(ECompaniesChangesActions.EditVacancyRequest),
        switchMap(action => {
          return this._companiesChangesService
            .editVacancy(action.id, action.data)
            .pipe(
              map(() => {
                this._store.dispatch(new EditVacancySuccess());
              }),
              catchError(err => {
                this._toastr.error(
                  `При редактировании вакансии возникла ошибка (patch)`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(new EditVacancyFailure(err));
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );
}
